// Chrome autocomplete="off" does not works
// https://stackoverflow.com/a/30976223
export const AUTOCOMPLETE_OFF = 'input-off';
